export const isProduction = process.env.NEXT_PUBLIC_APP_ENV === "production";

// Optionally disable pregenerated templates when building the app locally. This
// saves time when iterating on features unrelated to templates. This option
// shouldn't be available in the sandbox, staging, or production environments,
// so we enforce this by checking the NEXT_PUBLIC_APP_ENV environment variable.
export const disablePregeneratedTemplates: boolean =
  process.env.NEXT_PUBLIC_APP_ENV === "development" &&
  process.env.DISABLE_PREGENERATED_TEMPLATES === "true";
